export function isClient() {
    return globalThis.constructor.name === 'Window';
}
